import qs from "query-string";

const usePreview = () => {
  const search = qs.parse(window.location.search);
  return search.preview === "1";
};

export default usePreview;
